import { useCallback } from "react";
import { useHubSpotAdapterAxiosInstance } from "./useHubSpotAdapterAxiosInstance.ts";
import dayjs from "dayjs";
import { useWithLoading } from "../UI/Loading/useWithLoading.ts";

export function useExportHubSpotCloserAvailability() {
  const axiosInstance = useHubSpotAdapterAxiosInstance();
  const { withLoading, loading } = useWithLoading<void>();

  const exportAvailabilityCall = useCallback(
    async ({
      fromIncl,
      toIncl,
      filteredEmails,
    }: {
      fromIncl: Date;
      toIncl: Date;
      filteredEmails?: string[];
    }) => {
      const formattedFromIncl = dayjs(fromIncl).format();
      const formattedToIncl = dayjs(toIncl).format();

      const emailsParam =
        filteredEmails && filteredEmails.length > 0
          ? `&filteredEmails=${encodeURIComponent(filteredEmails.join(","))}`
          : "";

      const response = await axiosInstance.get(
        `/closer-availability/export-csv?fromIncl=${encodeURIComponent(formattedFromIncl)}&toIncl=${encodeURIComponent(formattedToIncl)}${emailsParam}`,
        { responseType: "blob" },
      );

      const contentDisposition = response.headers["content-disposition"];
      const filenameMatch = contentDisposition?.match(/filename="(.+)"/);
      const filename = filenameMatch
        ? filenameMatch[1]
        : `closer_availability_${dayjs(fromIncl).format("YYYY-MM-DD")}_to_${dayjs(toIncl).format("YYYY-MM-DD")}.csv`;

      const blob = new Blob([response.data], {
        type: "text/csv; charset=utf-8",
      });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    [axiosInstance],
  );

  const exportHubSpotCloserAvailability = useCallback(
    async ({
      fromIncl,
      toIncl,
      filteredEmails,
    }: {
      fromIncl: Date;
      toIncl: Date;
      filteredEmails?: string[];
    }) => {
      return await withLoading(() =>
        exportAvailabilityCall({ fromIncl, toIncl, filteredEmails }),
      );
    },
    [withLoading, exportAvailabilityCall],
  );

  return {
    exportHubSpotCloserAvailability,
    loading,
  };
}
